import type { AxiosError, AxiosResponse } from "axios";
import { HttpStatusCode } from "../../../../legacy/common/http-status-code";
import { AuthenticationService } from "../../../../legacy/services/authentication-service/authentication.service";
import type { IAuthenticationService } from "../../../../legacy/services/authentication-service/authentication.service.interface";
import type { IAxiosInterceptorAuthorization } from "./axios-interceptor-authorization.interface";

export class AxiosInterceptorAuthorization implements IAxiosInterceptorAuthorization {
  constructor(private readonly _logoutService: IAuthenticationService = new AuthenticationService()) {}

  async onFulfilled(value: AxiosResponse): Promise<AxiosResponse> {
    return value;
  }

  async onRejected(error: AxiosError): Promise<unknown> {
    const isUnauthorized = error?.response?.status === HttpStatusCode.UNAUTHORIZED;

    if (isUnauthorized) {
      await this._logoutService.logoutAndResetStorage();
    }

    return Promise.reject(error);
  }
}
